import React, { PureComponent } from 'react'
import { Card, Button, Header, Grid, Segment } from 'semantic-ui-react'
import firebase from 'firebase/app'
import { connect } from 'react-redux'
import moment from 'moment'
import _ from 'lodash'

import CategorySectionForm from './CategorySectionForm'
import CategorySectionCard from './CategorySectionCard'

const initData = {
  category: '',
  title: '',
  started_at: Number(
    moment()
      .startOf('day')
      .format('x')
  ),
  expired_at: Number(
    moment()
      .endOf('day')
      .format('x')
  ),
  time_frame: {
    monday: { from: '0:00', to: '0:00' },
    tuesday: { from: '0:00', to: '0:00' },
    wednesday: { from: '0:00', to: '0:00' },
    thursday: { from: '0:00', to: '0:00' },
    friday: { from: '0:00', to: '0:00' },
    saturday: { from: '0:00', to: '0:00' },
    sunday: { from: '0:00', to: '0:00' },
  },
}

class CategorySection extends PureComponent {
  state = { removing: false, saving: false, formSectionData: null, action: '' }

  onAddOrEditSection = (section = {}) => {
    this.setState({
      formSectionData: { ...initData, ...section.meal_time },
      action: section.meal_time ? 'edit' : 'new',
    })
  }

  onFieldChange = (field, value) => {
    let { formSectionData } = this.state

    formSectionData = {
      ...formSectionData,
      [field]: value,
    }

    this.setState({ formSectionData })
  }

  onSaveSection = async () => {
    const { formSectionData } = this.state
    const { fetchSelectedCategories } = this.props

    try {
      const updates = {}

      this.setState({ saving: true })

      updates[`selected_categories/${formSectionData.category}/meal_time/category`] = formSectionData.category
      updates[`selected_categories/${formSectionData.category}/meal_time/started_at`] = formSectionData.started_at
      updates[`selected_categories/${formSectionData.category}/meal_time/expired_at`] =
        formSectionData.expired_at
      updates[`selected_categories/${formSectionData.category}/meal_time/time_frame`] =
        formSectionData.time_frame
      updates[`selected_categories/${formSectionData.category}/meal_time/title`] = formSectionData.title

      const err = await firebase
        .database()
        .ref()
        .update(updates)

      if (err) throw err

      this.setState({ saving: false, formSectionData: null })
      fetchSelectedCategories()
    } catch (error) {
      this.setState({ saving: true })
      alert(error.message || error)
    }
  }

  onRemoveSection = async () => {
    const { formSectionData } = this.state
    const { fetchSelectedCategories } = this.props

    try {
      const updates = {}

      this.setState({ removing: true })

      updates[`selected_categories/${formSectionData.category}/meal_time`] = null

      const err = await firebase
        .database()
        .ref()
        .update(updates)

      if (err) throw err

      this.setState({ removing: false, formSectionData: null })
      fetchSelectedCategories()
    } catch (error) {
      this.setState({ removing: true })
      alert(error.message || error)
    }
  }

  renderNoResults = () => {
    return <div style={{ margin: 30 }}>No results</div>
  }

  renderSections = () => {
    const { categoriesData, categorySections } = this.props

    return (
      <Card.Group style={{ margin: 0 }}>
        {categorySections.map((section) => (
          <CategorySectionCard
            key={section.meal_time.category}
            mealTime={section.meal_time}
            categoryName={categoriesData[section.meal_time.category]}
            onEditClick={() => this.onAddOrEditSection(section)}
          />
        ))}
      </Card.Group>
    )
  }

  render() {
    const { formSectionData, saving, removing } = this.state
    const { categorySections } = this.props

    return (
      <Grid>
        <Grid.Column width="16">
          <Segment color="black">
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                flex: 1,
              }}
            >
              <Header style={{ margin: 0 }} size="large">
                Category Section
              </Header>

              <Button icon color="black" onClick={this.onAddOrEditSection}>
                Add Section
              </Button>
            </div>
            <div style={{ marginTop: 20 }}>
              {categorySections.length > 0 ? this.renderSections() : this.renderNoResults()}
            </div>
            {formSectionData && (
              <CategorySectionForm
                {...this.state}
                {...this.props}
                saving={saving}
                removing={removing}
                onClose={() => this.setState({ formSectionData: null })}
                onFieldChange={this.onFieldChange}
                saveSection={this.onSaveSection}
                onRemove={this.onRemoveSection}
              />
            )}
          </Segment>
        </Grid.Column>
      </Grid>
    )
  }
}

const mapState = ({ menus }) => ({
  selectedCategories: menus.selectedCategories,
  categorySections: _.filter(
    menus.selectedCategories,
    selectedCategory => _.size(selectedCategory.meal_time) > 0
  ),
})

export default connect(mapState)(CategorySection)



// WEBPACK FOOTER //
// ./src/containers/category/components/CategorySection.js